import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PartnerService from "services/PartnerService";

const initialState = {
  partners: [],
  loading: false,
  error: null,
  currentPage: 1,
  totalPages: 1,
  totalItems: 0,
};

export const getPartners = createAsyncThunk(
  "partners/getAll",
  async ({ page = 1, searchValue = {} }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setCurrentPage(page));
      const response = await PartnerService.getAllPartners(searchValue, page);

      dispatch(clearStates());
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Erreur");
    }
  }
);

// GET BY ID
export const getPartnerById = createAsyncThunk(
  "partners/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PartnerService.getPartnerById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Erreur");
    }
  }
);
// update partner status
export const updatePartnerStatus = createAsyncThunk(
  "partners/updateStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await PartnerService.updatePartnerStatus(id, status);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Erreur");
    }
  }
);

// CREATE
export const createPartner = createAsyncThunk(
  "partners/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PartnerService.createPartner(data);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data?.error || "Erreur");
    }
  }
);

// UPDATE
export const updatePartner = createAsyncThunk(
  "partners/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PartnerService.updatePartnerById(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Erreur");
    }
  }
);

// DELETE
export const deletePartner = createAsyncThunk(
  "partners/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PartnerService.deletePartnerById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Erreur");
    }
  }
);

// SLICE
const partnerSlice = createSlice({
  name: "partners",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    hideLoading: (state) => {
      state.loading = false;
    },
    hideError: (state) => {
      state.error = null;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    clearStates: (state) => {
      state.partners = [];
      state.totalItems = 0;
      state.totalPages = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getPartners.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPartners.fulfilled, (state, action) => {
        state.partners = action.payload.data;
        state.totalItems = action.payload.total;
        state.currentPage = action.payload.page;
        state.totalPages = action.payload.totalPages;
        state.loading = false;
        state.error = null;
      })

      .addCase(getPartners.rejected, (state, action) => {
        state.partners = [];
        state.loading = false;
        state.error = action.payload;
      })

      // GET BY ID
      .addCase(getPartnerById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPartnerById.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getPartnerById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createPartner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPartner.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createPartner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updatePartner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePartner.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updatePartner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE
      .addCase(deletePartner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePartner.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deletePartner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePartnerStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const { id, status } = action.meta.arg;
        const partner = state.partners.find((p) => p.id === id);
        if (partner) {
          partner.status = status;
        }
      });
  },
});

export default partnerSlice.reducer;

export const {
  showLoading,
  hideLoading,
  hideError,
  setCurrentPage,
  clearStates,
} = partnerSlice.actions;
